import IntegrationMessagesView from './IntegrationMessagesView';

const DevOutboxView = () => (
  <IntegrationMessagesView
    box="outbox"
    title="Outbox"
    description="Integrationsbeskeder som TaskService sender til D365"
  />
);

export default DevOutboxView;
